// extracted by mini-css-extract-plugin
module.exports = {"Content":"EventDetails_Content__2xJQS","Fixed":"EventDetails_Fixed__3oRYG","Scroll":"EventDetails_Scroll__2K6lh"};